// extracted by mini-css-extract-plugin
export default {"container":"DiscountsTab_container__6Pvlj","listTariffs":"DiscountsTab_listTariffs__Gz2Rk"};